import { List, ListItem } from "@mui/material";
import { type ReactNode } from "react";

interface BulletListCellProps {
  items: { item: ReactNode; id: string | number }[];
  indent?: number;
}

// TODO: Handle Nested Lists (recursion)
const BulletListCell = ({ items, indent = 3 }: BulletListCellProps) => {
  return (
    <List sx={{ listStyleType: "disc", pl: indent }}>
      {items.map(({ item, id }) => (
        <ListItem key={id} disablePadding sx={{ display: "list-item" }}>
          {item}
        </ListItem>
      ))}
    </List>
  );
};

export default BulletListCell;
